<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSend_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path fill="currentColor" d="M1 14v-4l6-2-6-2V2l15 6z" />
</svg>
